import { render, staticRenderFns } from "./QuickTagCreate.vue?vue&type=template&id=5ed31bdc&scoped=true"
import script from "./QuickTagCreate.vue?vue&type=script&lang=js"
export * from "./QuickTagCreate.vue?vue&type=script&lang=js"
import style0 from "./QuickTagCreate.vue?vue&type=style&index=0&id=5ed31bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed31bdc",
  null
  
)

export default component.exports